//我的挂牌列表
<template>
  <div>
    <header-img :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">我的挂牌</div>
      <choose-search @handleQuery="changeQuery" :searchInfo.sync="search"></choose-search>
      <div class="table">
        <el-table class="financial-services-table" :data="tableData" v-loading="Loading" :header-cell-style="{
            textAlign: 'center',
            background: '#FAFAFA',
            color: '#3F434B',
          }" :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="name" label="标的名称"></el-table-column>
          <el-table-column prop="areaConfigName" label="区域"></el-table-column>
          <el-table-column prop="businessTypeDesc" label="业务类型"></el-table-column>
          <el-table-column prop="transferTypeDesc" label="交易方式"></el-table-column>
          <el-table-column prop="applyTime" label="挂牌申请提交时间"></el-table-column>
          <el-table-column prop="statusDesc" label="状态">
            <template slot-scope="scope">
              <div class="statusBtn" @click="rowDetailEvt(scope.row, 1)" :class="
                  scope.row.statusDesc == '未通过'
                    ? 'noPass'
                    : scope.row.statusDesc.indexOf('已通过') != -1 ||
                      scope.row.statusDesc == '挂牌中'
                    ? 'pass'
                    : scope.row.statusDesc == '审批中'
                    ? 'passS'
                    : ''
                ">
                {{ scope.row.statusDesc || '--' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="其他操作">
            <template slot-scope="scope">
              <div class="statusBtn" @click="showEvt(scope.row)" :class="
                  scope.row.otherOperationStatus &&
                  scope.row.otherOperation == '申请中止挂牌'
                    ? 'noPass'
                    : scope.row.otherOperationStatus &&
                      scope.row.otherOperation == '申请交易鉴证书'
                    ? 'passS'
                    : ''
                ">
                {{ scope.row.otherOperation || '--' }}
              </div>
              <a v-if="scope.row.statusDesc != '未通过'&&scope.row.statusDesc != '审批中'&&!!scope.row.equityTransactionUrl" class="check-btn" :href="scope.row.equityTransactionUrl" target="_blank">查看委托合同</a>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div class="statusBtn" @click="detailUrl(scope.row)" :class="
                  scope.row.operationStatus == '已驳回'
                    ? 'noPass'
                    : scope.row.operationStatus == '已发放'
                    ? 'pass'
                    : scope.row.operationStatus == '已同意'
                    ? 'passS'
                    : ''
                ">
                {{ scope.row.operationStatus || '--' }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <Pagination :total="paginationParam.total" :page.sync="paginationParam.pageNumber" :limit.sync="paginationParam.pageSize" @pagination="getTransactionList" />
      </div>
      <!-- 中止挂牌 -->
      <Dialog :show.sync="diaShow" @dialogClose="diaShow = false" :title="'温馨提示'" :content="'确定申请中止挂牌？'" :btn="'取消'" :btn2="'确定'" />
      <!-- 申请交易鉴证书 -->
      <el-dialog width="30%" title="请选择鉴证书方式" :visible.sync="show" append-to-body :close-on-click-modal="false">
        <el-row style="text-align: center">
          <el-form ref="formRef" :model="diaFormData" :rules="diaRule" label-width="120px" label-position="left" size="mini">
            <el-radio-group v-model="diaFormData.applyVersion" style="margin: 20px auto; text-align: left; width: 100%">
              <el-radio :label="1">电子版</el-radio>
              <el-radio :label="2">纸质版</el-radio>
            </el-radio-group>
            <el-form-item label="收件人姓名">
              <el-input v-model="diaFormData.receiverName" :disabled="diaFormData.applyVersion == 1" placeholder="请输入收件人姓名">
              </el-input>
            </el-form-item>
            <el-form-item label="收件人联系电话">
              <el-input v-model="diaFormData.receiverPhone" :maxlength="11" :disabled="diaFormData.applyVersion == 1" @keyup.native="changeCode('receiverPhone')" placeholder="请输入收件人联系电话">
              </el-input>
            </el-form-item>
            <el-form-item label="收件人家庭住址">
              <el-input v-model="diaFormData.receiverAddress" :disabled="diaFormData.applyVersion == 1" placeholder="请输入收件人家庭住址">
              </el-input>
            </el-form-item>
          </el-form>
          <div class="btnDia">
            <el-button @click="diaClose">取消</el-button>
            <el-button @click="diaSubmit" class="btn-2">提交</el-button>
          </div>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ChooseSearch from "@/components/ChooseSearch/index.vue";
import Dialog from "@/components/Dialog";
import publicFunction from "@/utils/publicFunction";
import HeaderImg from "@/components/HeaderImg";
import { sessionStore } from "@/utils/data-management";
import Pagination from "@/components/Pagination";
export default {
  components: {
    ChooseSearch,
    Dialog,
    HeaderImg,
    Pagination
  },
  data() {
    return {
      headerList: [{ name: "首页", path: "/Home" }, { name: "我的挂牌" }],
      diaShow: false,
      show: false,
      Loading: false,
      tableData: [],
      paginationParam: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      search: {},
      total: 0,
      diaFormData: {
        listingApplyId: "", //列表id
        receiverName: "",
        receiverPhone: "",
        receiverAddress: "",
        applyPersonType: 1, //1挂牌方 2摘牌方
        applyVersion: 1 //1电子版 2纸质版
      },
      diaRule: {
        receiverName: [{ required: true, message: "请输入", trigger: "blur" }],
        receiverPhone: [{ required: true, message: "请输入", trigger: "blur" }],
        receiverAddress: [
          { required: true, message: "请输入", trigger: "blur" }
        ]
      }
    };
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name == "MyApplyRuralDetail" ||
      to.name == "myCertificateDetail" ||
      to.name == "MyApplyForestDetail"
    ) {
      let pageParams = {
        formInfo: this.search,
        paginationParam: this.paginationParam
      };
      sessionStore.set("pageParams", JSON.stringify(pageParams));
    } else if (sessionStore.get("pageParams")) {
      sessionStore.remove("pageParams");
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next(vim => {
      let pageParams = sessionStore.get("pageParams");
      if (
        (from.name == "MyApplyRuralDetail" ||
          from.name == "myCertificateDetail" ||
          from.name == "MyApplyForestDetail") &&
        pageParams
      ) {
        pageParams = JSON.parse(pageParams);
        vim.search = pageParams.formInfo;
        vim.paginationParam = pageParams.paginationParam;
      }
      vim.getTransactionList();
    });
  },
  methods: {
    detailUrl(row) {
      if (row.operationStatus == "已发放") {
        sessionStore.set("CertificateDetail", row);
        this.$router.push({
          name: "myCertificateDetail",
          query: { listSource: "gp" }
        });
      }
    },
    rowDetailEvt(row, flag) {
      let type = row.businessType * 1
      if(type == 1){
        this.$router.push({
          name: "MyApplyRuralDetail",
          query: {
            id: row.id,
            status: row.status,
            businessType: row.businessType
          }
        });
      } else if (type == 2){
        this.$router.push({
          name: "MyApplyForestDetail",
          query: {
            id: row.id,
            status: row.status,
            businessType: row.businessType
          }
        });
      } else {
        this.$router.push({
          name: "MyApplyCustomDetail",
          query: {
            id: row.id,
            status: row.status,
            businessType: row.businessType
          }
        });
      }
    },
    showEvt(row) {
      if (row.otherOperationStatus) {
        this.diaFormData.listingApplyId = row.id;
        if (row.otherOperation == "申请交易鉴证书") {
          this.show = true;
          this.diaFormData = {
            listingApplyId: row.id, //列表id
            receiverName: "",
            receiverPhone: "",
            receiverAddress: "",
            applyPersonType: 1, //1挂牌方 2摘牌方
            applyVersion: 1 //1电子版 2纸质版
          };
        }
        if (row.otherOperation == "申请中止挂牌") {
          this.diaShow = true;
        }
      }
    },
    diaClose() {
      this.$refs.formRef.resetFields();
      this.show = false;
    },
    diaSubmit() {
      if (this.diaFormData.applyVersion == 2) {
        if (!this.diaFormData.receiverName)
          return this.$message.error("请输入姓名");
        if (!this.diaFormData.receiverPhone)
          return this.$message.error("请输入电话");
        if (!this.diaFormData.receiverAddress)
          return this.$message.error("请输入地址");
      }
      this.certificateEvt();
    },
    //申请鉴定书
    certificateEvt() {
      this.Loading = true;
      this.$api.my
        .certificate(this.diaFormData)
        .then(res => {
          if (res.code == 1000) {
            this.show = false;
            this.$message.success("申请成功");
            this.getTransactionList();
          }
        })
        .catch(error => {})
        .finally(() => {
          this.Loading = false;
        });
    },
    //查询
    changeQuery(query) {
      if (query.chooseValue != 0) {
        this.$set(this.search, "startDate", query.chooseValue);
      } else {
        this.$set(this.search, "startDate", null);
      }
      if (query.searchValue) {
        this.$set(this.search, "name", query.searchValue);
      } else {
        this.$set(this.search, "name", null);
      }
      if (query.chooseIndex) {
        this.$set(this.search, "chooseIndex", query.chooseIndex);
      } else {
        this.$set(this.search, "chooseIndex", -1);
      }
      this.paginationParam.pageNumber = 1;
      this.getTransactionList();
    },
    getTransactionList() {
      this.Loading = true;
      const params = {
        userId: this.$store.state.userInfo.id,
        areaConfigId: this.$store.state.cityArea.areaConfigId,
        ...this.search,
        ...this.paginationParam
      };
      this.$api.my
        .applyList(params)
        .then(res => {
          if (res.code == 1000) {
            this.tableData = res.data;
            this.paginationParam.total = res.total;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(error => {})
        .finally(() => {
          this.Loading = false;
        });
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.getTransactionList();
    },
    dialogSumbitL() {
      this.diaShow = false;
    },
    dialogSumbitR() {
      this.Loading = true;
      this.$api.my
        .pauseApprove({ id: this.diaFormData.listingApplyId })
        .then(res => {
          if (res.code == 1000) {
            this.diaShow = false;
            this.$message.success("申请中止成功");
            this.getTransactionList();
          }
        })
        .catch(error => {})
        .finally(() => {
          this.Loading = false;
        });
    },
    changeCode(name) {
      this.$nextTick(() => {
        if (this.diaFormData[`${name}`] != null) {
          this.diaFormData[`${name}`] = this.diaFormData[`${name}`].replace(
            /[^\d.]/g,
            ""
          );
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
  .check-btn{
    color: #4f79d0;
    cursor: pointer;
    text-decoration: none;
  }
</style>
